module.exports = ".cancel{\nmargin-left: 60px;\n}\n\n"